module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"info":"个人中心","logout":"退出登录"},"TW":{"info":"個人中心","logout":"登出"},"en":{"info":"Edit Info","logout":"Log out"}}')
  delete Component.options._Ctor
}
